<template>
  <div class="Toast" :class="mode">
    <div class="content">
      <ToastCheck v-if="mode === 'success'" class="ToastIcon" />
      <ToastWarning v-if="mode === 'warn'" class="ToastIcon" />
      <Error v-if="mode === 'error'" class="ToastIcon" />
      <p class="ToastText">
        <slot />
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ToastCheck, ToastWarning, Error } from '@ka-nabellinc/ka-nabell-icons'

export default defineComponent({
  components: {
    ToastCheck,
    ToastWarning,
    Error,
  },
  props: {
    mode: {
      type: String as () => 'success' | 'warn' | 'error',
      default: 'success',
    }
  }
})
</script>

<style scoped>
.Toast {
  width: 343px;
  padding: 12px;
  align-items: center;
  border-radius: 8px;
  z-index: 100000;
}

.success {
  border: 1px solid var(--primitive-colors-system-green-300);
  background: var(--primitive-colors-system-green-100);
  box-shadow: var(--elevation-shadow-200);
  color: var(--primitive-colors-system-green-800);
}

.warn {
  border: 1px solid var(--primitive-colors-system-orange-300);
  background: var(--primitive-colors-system-orange-100);
  box-shadow: var(--elevation-shadow-200);
  color: var(--primitive-colors-system-orange-800);
}

.error {
  border: 1px solid var(--primitive-colors-system-red-300);
  background: var(--primitive-colors-system-red-100);
  box-shadow: var(--elevation-shadow-300);
  color: var(--primitive-colors-system-red-700);
}

.content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ToastIcon {
  flex-basis: 24px;
  flex-shrink: 0;
}

.ToastText {
  font-size: var(--font-size-body-2);
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.13px;
  margin: 0;
}
</style>
